<!--suppress ALL -->
<template>
  <div>
    <el-footer
      :style="hiddeFooter"
      height="500px"
      class="footer">
      <!--<div class="footer-newsletter">
        <div class="footer-newsletter-grid ">
          <el-row
            :gutter="20"
            type="flex"
            align="middle"
            class="newsletter">
            <el-col
              :span="16"
              :offset="4">
              <div class="text-newsletter">
                <h1>¡Recibe nuestro newsletter!</h1>
              </div>
              <div class="input-newsletter">
                <el-input
                  placeholder="Correo electrónico">
                  <el-button
                    slot="append">Inscribirme
                  </el-button>
                </el-input>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>-->
      <div class="footer-link-container">
        <div
          class="footer-link-content">
          <el-row
            :gutter="20"
            type="flex"
            align="middle"
            class="footer-info">
            <el-col
              :offset="1"
              :xs="24"
              :sm="7"
              :md="7"
              :lg="7"
              :xl="7"
              class="columns">
              <el-row>
                <router-link :to="{name: 'Home'}">
                  <el-col class="logo">
                    <img
                      widt="238"
                      height="46"
                      src="@/assets/images/logoWR.svg">
                  </el-col>
                </router-link>
                <el-col class="icon-list">
                  <a
                    href="https://www.facebook.com/myticketmx/"
                    target="_blank">
                    <i class="icon-facebook"/>
                  </a>
                  <a
                    href="https://www.facebook.com/myticketmx/"
                    target="_blank">
                    <i class="icon-instagram"/>
                  </a>
                  <a
                    href="https://www.facebook.com/myticketmx/"
                    target="_blank">
                    <i class="icon-twitter"/>
                  </a>
                  <a
                    href="https://www.facebook.com/myticketmx/"
                    target="_blank">
                    <i class="icon-youtube-play"/>
                  </a>
                </el-col>
                <el-col class="footer-links">
                  <a>Políticas de privacidad</a>
                </el-col>
                <el-col>
                  <a>Términos y condiciones</a>
                </el-col>
              </el-row>
            </el-col>
            <el-col
              :offset="1"
              :span="4"
              class="columns hidden-xs-mt">
              <el-row>
                <el-col class="title">
                  <span>Myticket</span>
                </el-col>
                <el-col class="footer-links">
                  <a>Nosotros</a>
                </el-col>
                <el-col class="footer-links">
                  <a>Puntos de venta Myticket</a>
                </el-col>
                <el-col class="footer-links">
                  <a>Vende con nosotros</a>
                </el-col>
                <el-col>
                  <a>Preguntas frecuentes</a>
                </el-col>
              </el-row>
            </el-col>
            <el-col
              :offset="1"
              :span="4"
              class="columns hidden-xs-mt">
              <el-row>
                <el-col class="title">
                  <span>Vende con nosotros</span>
                </el-col>
                <el-col class="footer-links">
                  <a>Beneficios</a>
                </el-col>
                <el-col class="footer-links">
                  <a>Tecnología</a>
                </el-col>
                <el-col class="footer-links">
                  <a>Puntos de venta Myticket</a>
                </el-col>
                <el-col>
                  <a>Quiero ser partner</a>
                </el-col>
              </el-row>
            </el-col>
            <el-col
              :offset="1"
              :span="4"
              class="columns hidden-xs-mt">
              <el-col class="title">
                <span>Contacto</span>
              </el-col>
              <el-col class="footer-links">
                <p>Si tienes alguna duda o <br> comentario, no dudes en <br> contáctanos</p>
              </el-col>
              <el-col class="footer-links">
                <a>+52(442) 22 30 600</a>
              </el-col>
              <el-col class="footer-links">
                <a>contacto@myticket.com.mx</a>
              </el-col>
              <el-col>
                <!--<el-button class="btn-contact">Contacto</el-button>-->
              </el-col>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="footer-copyright">
        <div class="footer-copyright-content">
          <span>
            &#x24B8;2018 Todos los derechos reservados
          </span>
        </div>
      </div>
    </el-footer>
  </div>
</template>

<script>
export default {
  name: 'MTfooter',
  components: {
  },
  data () {
    return {
      data: {
        windowWidthw: 0,
        bgColor: '#2B303A',
        padding: 0
      }
    }
  },
  computed: {
    windowWidth () {
      return window.innerWidth
    },
    hiddeFooter () {
      if (this.windowWidth <= 414) {
        return {
          display: this.$route.meta.hidden + '!important'
        }
      }
    }
  },
  methods: {
    goToPoint () {
      this.$router.push({name: 'faq'})
    },
    goToFacebook () {
      window.location.href('https://www.facebook.com/myticketmx/')
    }
  }
}
</script>

<style lang="scss" scoped>

  .hidden-xs-mt{
    @media #{$iPad} {
      display: none;
    }
  }

///////////////////////////
a{
  color: #AAB1BF !important;
  @include font-primary(12px, regular);
  cursor: pointer;
  text-decoration: none !important;
  &:hover{
    color: white !important;
  }
}
p{
  color: #AAB1BF !important;
  margin-top: 0;
  margin-bottom: 11px;
  @include font-primary(12px, regular);
  &:hover{
    color: white !important;
  }
}
span{
  @include font-primary(16, semibold);
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/footer/footer.vue